module.exports = __webpack_public_path__ + "img/ilich.e2f0754e.svg";